/** Relative time helper, e.g. "3h ago". */
export function timeAgo(unixSeconds: number): string {
  const diff = Math.max(1, Math.floor(Date.now() / 1000) - unixSeconds);
  const units: [number, string][] = [
    [60, 's'],
    [60, 'm'],
    [24, 'h'],
    [7, 'd'],
    [4.345, 'w'],
    [12, 'mo'],
    [Number.MAX_SAFE_INTEGER, 'y'],
  ];
  let value = diff;
  let suffix = 's';
  for (const [size, label] of units) {
    suffix = label;
    if (value < size) break;
    value = Math.floor(value / size);
  }
  return `${value}${suffix} ago`;
}

/** Deterministic hue + initials avatar fallback (no gravatar). */
export function avatarFallback(pubkey: string): { hue: number; initials: string } {
  let hash = 0;
  for (let i = 0; i < pubkey.length; i++) {
    hash = (hash * 31 + pubkey.charCodeAt(i)) >>> 0;
  }
  return { hue: hash % 360, initials: pubkey.slice(0, 2).toUpperCase() };
}

/** Shorten a hex pubkey for display. */
export function shortPubkey(pubkey: string): string {
  return `${pubkey.slice(0, 8)}…${pubkey.slice(-4)}`;
}
